import {useEffect, useMemo, useState} from "react";
import {IFormaPagamentoForm} from "@models/formaPagamento/IFormaPagamento.ts";
import {ISolicitacaoOrcamento} from "@models/solicitacoes/orcamento.ts";
import {Grid, TextField} from "@mui/material";
import {useOrcamento} from "@components/orcamento/hooks/useOrcamento.ts";
import {IFormPagtoUpdateFormDto} from "@components/orcamento/models/IFormPagtoUpdateDto.ts";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {PermissionableButton} from "@shared/specialComponents/PermissionableButton.tsx";

export interface DadosPagtoEditorProps {
    forms: IFormaPagamentoForm[],
    orcamento: ISolicitacaoOrcamento | number
}

export function OrcamentoDadosPagtoEditor(props: DadosPagtoEditorProps) {
    const {createAlertFromResponse} = useAlert()
    const {useOrcamentoValue, getFormaPagtoFormsOrcamento, updateFormaPagtoForms} = useOrcamento()
    const [orcamento] = useOrcamentoValue(props.orcamento)
    const [entries, setEntries] = useState<(IFormPagtoUpdateFormDto & { nome?: string })[]>([])

    const isAlteravel = useMemo(() => {
        return !(orcamento?.dataPagamentoEfetuado != null || orcamento?.status == 'Cancelado');

    }, [orcamento]);

    useEffect(() => {
        if (orcamento != null && props.forms.length > 0 && entries.length == 0) {
            getFormaPagtoFormsOrcamento({
                data: {idOrcamento: orcamento.id},
                pagination: {page: 1, pageSize: props.forms.length}
            }).then(x => {
                if (x.items != null) {
                    const ent = props.forms.map(it => ({
                        formId: it.id,
                        nome: it.nome ?? '',
                        valor: x.items.find(y => y.formId == it.id)?.valor ?? ''
                    }))

                    setEntries([...ent])
                }
            })
        }
    }, [orcamento, props.forms]);

    return (<Grid container size={12}>
        {entries.map((x, i) => <Grid key={x.formId} size={12}>
            <TextField label={x.nome}
                       disabled={!isAlteravel}
                       value={x.valor}
                       onChange={(e) => {
                           setEntries(prev => {
                               const newent = [...prev]
                               newent[i].valor = e.target.value
                               return newent
                           })
                       }}/>
        </Grid>)}
        <Grid size={12}>
            <PermissionableButton permission={['CriarOrcamentoMembro']}
                                  showEvenWithoutAccess
                                  fullWidth
                                  disabled={!isAlteravel}
                                  onClick={() => {
                                      if (orcamento?.id != null)
                                          updateFormaPagtoForms({
                                              idOrcamento: orcamento?.id,
                                              forms: entries
                                          }).then(x => {
                                              createAlertFromResponse(x)
                                          })
                                  }}>Salvar</PermissionableButton>
        </Grid>
    </Grid>)
}